import React from 'react';
import { Button, Select, Space, Typography } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

const { Text } = Typography;

/**
 * Ô "Topic" của form gợi ý trên cms.next: nhiều nhóm, mỗi nhóm một ô chọn nhiều.
 * Các topic trong cùng nhóm là "Và", các nhóm với nhau là "Hoặc". Giá trị: string[][]
 * — API lưu mỗi nhóm thành một dòng suggestion_targets type 3 (nối dấu phẩy).
 */
const TopicGroupsInput = ({ value, onChange, options }) => {
  const groups = Array.isArray(value) && value.length > 0 ? value : [[]];

  const update = (next) => onChange?.(next);

  return (
    <Space direction="vertical" size={8} style={{ width: '100%' }}>
      {groups.map((group, index) => (
        // Nhóm không có id riêng nên dùng index làm key.
        <div key={index}>
          <div className="flex items-center justify-between mb-1">
            <Text type="secondary">Nhóm {index + 1}{index > 0 ? ' (hoặc)' : ''}</Text>
            {groups.length > 1 && (
              <Button
                type="link"
                size="small"
                danger
                icon={<DeleteOutlined />}
                onClick={() => update(groups.filter((_, i) => i !== index))}
              >
                Xoá nhóm
              </Button>
            )}
          </div>
          <Select
            mode="multiple"
            allowClear
            style={{ width: '100%' }}
            placeholder="Tất cả"
            optionFilterProp="label"
            options={options}
            value={Array.isArray(group) ? group : []}
            onChange={(selected) => update(groups.map((g, i) => (i === index ? selected : g)))}
          />
        </div>
      ))}
      <Button icon={<PlusOutlined />} onClick={() => update([...groups, []])}>
        Hoặc
      </Button>
    </Space>
  );
};

TopicGroupsInput.propTypes = {
  value: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({ value: PropTypes.string, label: PropTypes.string })),
};

TopicGroupsInput.defaultProps = {
  value: undefined,
  onChange: undefined,
  options: [],
};

export default TopicGroupsInput;
